export default __webpack_public_path__ + "static/media/middleImage_2_right.1ebd745b.png";